import styled, {keyframes} from 'styled-components';

const fadeOut = keyframes`
from {
  opacity: 1;
}
to {
  opacity: 0;
}
`;

export const FadingOutDiv = styled.div`
  pointer-events: none;
  position: relative;
  height: 100%;
  width: 100%;
  z-index: 200;
  background: white;
  animation-name: ${fadeOut};
  animation-duration: 3s;
  opacity: 0;
`;
